export interface TopicPartQuestion {
  id: string;
  topicPartId: string;
  text: string;
  answerType:
  | "text"
  | "singleChoice"
  | "multipleChoice"
  | "yesNo"
  | "yesNoUnknown";
  answers?: string[];
  rank?: number;
  comments?: string;
  created?: string;
  updated?: string;
}

export type TopicPartQuestionFormData = Omit<
  TopicPartQuestion,
  "id" | "rank" | "created" | "updated"
>;

export const emptyTopicPartQuestion = (
  topicPartId: string,
): TopicPartQuestionFormData => ({
  topicPartId,
  text: "",
  answerType: "text",
  answers: [],
  comments: "",
});

export const topicPartQuestionAnswerType: string[] = [
  "text",
  "choice",
  "singleChoice",
  "yesNo",
  "yesNoUnknown",
];
